import {put,takeLatest,call} from 'redux-saga/effects'
import * as superUserService from "../../../services/superUserService"
import {
    GET_SUPERUSERS,
    GET_SUPERUSERS_SUCCESS,
    GET_SUPERUSERS_ERROR
}
    from "../../actions/superuser"

function* getSupersUserSaga(action) {
    try {
        const data=yield call(superUserService.GetSuperUsers,action.payload)
        yield put({
            type: GET_SUPERUSERS_SUCCESS,
            payload: data
        })

    } catch(error) {
        yield put({
            type: GET_SUPERUSERS_ERROR,error: error.data
        })
    }
}


export function* getSuperUsersSagaWatcher() {
    yield takeLatest(GET_SUPERUSERS,getSupersUserSaga)
}